export const hasLinkedClient = ({ context }) => {
    return Boolean(context.clientId);
};
//# sourceMappingURL=student.js.map